<template>
  <div id="toSolBuy">
    <transition name="fade">
      <div class="small" @click="toSolBuy" v-if="searchBarFixed">
        <img class="h_img" src="@/assets/images/bug-icon.png" alt="">
      </div>
      <div class="toTop" @click="toSolBuy" v-if="!searchBarFixed">
        <img class="h_img" src="@/assets/images/bug-icon.png" alt="">
        <span class="h_txt">我购买的方案</span>
      </div>
    </transition>
  </div>
</template>

<script>
import { getCookie } from '@/utils/cookies'
import { toLogin } from '@/utils/common'
export default {
  name: 'toSolBuy',
  data () {
    return {
      searchBarFixed: false
    }
  },
  mounted () {
    var _this = this
    window.addEventListener('scroll', _this.handleScroll)
  },
  methods: {
    // 返回顶部
    toSolBuy () {
      // if (!getCookie('ticket') && $HMD$.rNavigator !== 'msite') {
      //   // 跳转登录页面
      //   $HMD$.M.sendApp({
      //     name: 'login',
      //     value: true
      //   })
      // } else
      try {
        const _this = this
        if (($HMD$.rNavigator === 'msite' && !getCookie('accountId')) || !getCookie('ticket')) {
          toLogin()
        } else {
          var gotoTop = function () {
            _this.$router.push(`/solutionBuy.html`)
          }
          gotoTop()
        }
      } catch (error) {

      }
    },
    handleScroll () {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      if (scrollTop > 10) {
        this.searchBarFixed = true
      } else {
        this.searchBarFixed = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.toTop {
  width: 130px;
  height: 36px;
  background: linear-gradient(143deg, #5CB2FF 0%, #2F7BFF 100%);
  box-shadow: 0px 2px 8px 0px rgba(0,47,107,0.4);
  border-radius: 23px;
  position: relative;
  margin-right: 15px;
}
.small{
    width: 41px;
    height: 36px;
    background: linear-gradient(143deg, #5CB2FF 0%, #2F7BFF 100%);
    box-shadow: 0px 2px 8px 0px rgba(0,47,107,0.4);
    border-radius: 23px 0 0 23px;
    text-align: center;
}
.small .h_img{
    width: 36px;
}
.toTop .h_img {
  width: 36px;
  margin-left: 3px;
}
.h_txt{
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 20px;
    text-shadow: 0px 2px 8px rgba(0, 47, 107, 0.4);
    position: absolute;
    top: 8px;
    right: 11px;
}
#toSolBuy {
  position: fixed;
  top: 82%;
  right: 0rem;
  cursor: pointer;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/toSolBuy.vue